import { g as p } from "./_commonjsHelpers-DaMA6jEr.js";
var g = function(r) {
  return o(r) && !c(r);
};
function o(e) {
  return !!e && typeof e == "object";
}
function c(e) {
  var r = Object.prototype.toString.call(e);
  return r === "[object RegExp]" || r === "[object Date]" || b(e);
}
var E = typeof Symbol == "function" && Symbol.for, y = E ? Symbol.for("react.element") : 60103;
function b(e) {
  return e.$$typeof === y;
}
function Q(e) {
  return Array.isArray(e) ? [] : {};
}
function d(e, r) {
  return r.clone !== !1 && r.isMergeableObject(e) ? l(Q(e), e, r) : e;
}
function f(e, r, a) {
  return e.concat(r).map(function(m) {
    return d(m, a);
  });
}
function A(e, r) {
  if (!r.customMerge)
    return l;
  var a = r.customMerge(e);
  return typeof a == "function" ? a : l;
}
function B(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(r) {
    return Object.propertyIsEnumerable.call(e, r);
  }) : [];
}
function u(e) {
  return Object.keys(e).concat(B(e));
}
function t(e, r) {
  try {
    return r in e;
  } catch {
    return !1;
  }
}
function C(e, r) {
  return t(e, r) && !(Object.hasOwnProperty.call(e, r) && Object.propertyIsEnumerable.call(e, r));
}
function D(e, r, a) {
  var m = {};
  return a.isMergeableObject(e) && u(e).forEach(function(i) {
    m[i] = d(e[i], a);
  }), u(r).forEach(function(i) {
    C(e, i) || (t(e, i) && a.isMergeableObject(r[i]) ? m[i] = A(i, a)(e[i], r[i], a) : m[i] = d(r[i], a));
  }), m;
}
function l(e, r, a) {
  a = a || {}, a.arrayMerge = a.arrayMerge || f, a.isMergeableObject = a.isMergeableObject || g, a.cloneUnlessOtherwiseSpecified = d;
  var m = Array.isArray(r), i = Array.isArray(e), F = m === i;
  return F ? m ? a.arrayMerge(e, r, a) : D(e, r, a) : d(r, a);
}
l.all = function(r, a) {
  if (!Array.isArray(r))
    throw new Error("first argument should be an array");
  return r.reduce(function(m, i) {
    return l(m, i, a);
  }, {});
};
var h = l, O = h;
const s = /* @__PURE__ */ p(O);
var T = {
  color: {
    neutral: {
      20: "#F9F6F3",
      30: "#EBE7E3",
      40: "#D4CFCB",
      50: "#8F8982",
      60: "#635E58",
      70: "#3F3B36",
      80: "#292929",
      white: "#FFFFFF",
      black: "#000000"
    },
    red: {
      20: "#FFEBEF",
      30: "#F5B2C1",
      40: "#EB748E",
      50: "#E04A6A",
      60: "#D62349",
      70: "#AE072C",
      80: "#730019"
    },
    orange: {
      20: "#FFEDE5",
      30: "#FFC6AD",
      40: "#F89B73",
      50: "#F17B49",
      60: "#E95D21",
      70: "#C13E06"
    },
    yellow: {
      70: "#CB7D07",
      80: "#8F5600"
    },
    green: {
      20: "#ADEAA6",
      30: "#3BE44C",
      40: "#16B639",
      50: "#0A9828",
      60: "#007226",
      70: "#044D29",
      80: "#00261C",
      90: "#051C16"
    },
    blue: {
      20: "#EBEFFF",
      30: "#AEBAFB",
      40: "#788AE9",
      50: "#4F66DE",
      60: "#1F3BCD",
      70: "#001EB2"
    },
    alert: {
      success: "#044D29",
      successTint: "#ADEAA6",
      warning: "#C13E06",
      warningTint: "#FFEDE5",
      error: "#AE072C",
      errorTint: "#FFEBEF",
      info: "#1F3BCD",
      infoTint: "#EBEFFF",
      neutral: "#001EB2",
      neutralTint: "#AEBAFB",
      border: "#FFFFFF"
    },
    input: {
      borderDim: "#EBE7E3"
    },
    brand: {
      brand: "#0A9828",
      dark: "#00261C",
      dim: "#044D29",
      bold: "#3BE44C",
      bright: "#ADEAA6",
      gradientFrom: "#ADEAA6",
      gradientTo: "#16B639",
      onBrand: "#FFFFFF",
      onBrandVariant: "#ADEAA6",
      fixed: {
        brand: "#0A9828",
        dark: "#00261C",
        dim: "#044D29",
        bold: "#3BE44C",
        bright: "#ADEAA6",
        onBrand: "#FFFFFF",
        onBrandVariant: "#ADEAA6"
      }
    },
    outline: {
      outer: "#4F66DE",
      inner: "#FFFFFF"
    },
    surface: {
      surface: "#F9F6F3",
      bright: "#FFFFFF",
      dim: "#EBE7E3",
      onSurface: "#00261C",
      onSurfaceVariant: "#635E58",
      border: "#EBE7E3",
      borderDim: "#D4CFCB",
      link: "#044D29",
      electricity: "#CB7D07",
      gas: "#4F66DE",
      fadeFrom: "rgb(0 38 28 / 0)",
      fadeTo: "#00261C",
      fixed: {
        onSurface: "#FFFFFF",
        bright: "#00261C"
      }
    }
  },
  transition: {
    duration: {
      fast: 200,
      medium: 300,
      slow: 500
    }
  },
  unit: {
    0: 0,
    25: 1,
    50: 2,
    100: 4,
    200: 8,
    300: 12,
    350: 14,
    400: 16,
    450: 18,
    500: 20,
    550: 22,
    600: 24,
    700: 28,
    800: 32,
    900: 36,
    1e3: 40,
    1100: 44,
    1200: 48,
    1300: 52,
    1400: 56,
    1500: 60,
    1600: 64,
    1800: 72,
    2e3: 80,
    2400: 96,
    3e3: 120,
    3500: 140
  },
  border: {
    radius: {
      xs: 2,
      sm: 4,
      md: 8,
      lg: 12,
      xl: 16,
      "2xl": 22,
      "3xl": 32
    },
    width: {
      sm: 1,
      md: 2,
      lg: 4
    }
  },
  breakpoint: {
    small: 576,
    medium: 960,
    large: 1200
  },
  native: {
    font: {
      family: {
        black: "OVOCircularTT-Black",
        book: "OVOCircularTT-Book",
        bold: "OVOCircularTT-Bold"
      }
    }
  },
  web: {
    font: {
      family: "'OVOCircular', Futura, 'Century Gothic', sans-serif"
    }
  },
  font: {
    letterSpacing: {
      d1: {
        mediaQuery: {
          sm: -3,
          lg: -6
        }
      },
      d2: {
        mediaQuery: {
          sm: -2.5,
          lg: -5
        }
      },
      d3: {
        mediaQuery: {
          sm: -2,
          lg: -4
        }
      },
      d4: {
        mediaQuery: {
          sm: -1.5,
          lg: -3
        }
      },
      "4xl": {
        mediaQuery: {
          sm: -1,
          lg: -2
        }
      },
      "3xl": {
        mediaQuery: {
          sm: -0.5,
          lg: -1
        }
      },
      "2xl": {
        mediaQuery: {
          sm: -0.5,
          lg: -1
        }
      },
      xl: {
        mediaQuery: {
          sm: -0.5,
          lg: -1
        }
      },
      lg: {
        mediaQuery: {
          sm: 0,
          lg: 0
        }
      },
      md: {
        mediaQuery: {
          sm: 0,
          lg: 0
        }
      },
      sm: {
        mediaQuery: {
          sm: 0,
          lg: 0
        }
      },
      xs: {
        mediaQuery: {
          sm: 0,
          lg: 0
        }
      }
    },
    lineHeight: {
      d1: {
        mediaQuery: {
          sm: 80,
          lg: 120
        }
      },
      d2: {
        mediaQuery: {
          sm: 64,
          lg: 96
        }
      },
      d3: {
        mediaQuery: {
          sm: 64,
          lg: 80
        }
      },
      d4: {
        mediaQuery: {
          sm: 48,
          lg: 64
        }
      },
      "4xl": {
        mediaQuery: {
          sm: 32,
          lg: 48
        }
      },
      "3xl": {
        mediaQuery: {
          sm: 32,
          lg: 40
        }
      },
      "2xl": {
        mediaQuery: {
          sm: 28,
          lg: 36
        }
      },
      xl: {
        mediaQuery: {
          sm: 28,
          lg: 32
        }
      },
      lg: {
        mediaQuery: {
          sm: 24,
          lg: 28
        }
      },
      md: {
        mediaQuery: {
          sm: 20,
          lg: 24
        }
      },
      sm: {
        mediaQuery: {
          sm: 16,
          lg: 20
        }
      },
      xs: {
        mediaQuery: {
          sm: 14,
          lg: 14
        }
      }
    },
    paragraphSpace: {
      d1: {
        mediaQuery: {
          sm: 48,
          lg: 64
        }
      },
      d2: {
        mediaQuery: {
          sm: 64,
          lg: 80
        }
      },
      d3: {
        mediaQuery: {
          sm: 64,
          lg: 96
        }
      },
      d4: {
        mediaQuery: {
          sm: 80,
          lg: 120
        }
      },
      "4xl": {
        mediaQuery: {
          sm: 32,
          lg: 48
        }
      },
      "3xl": {
        mediaQuery: {
          sm: 28,
          lg: 32
        }
      },
      "2xl": {
        mediaQuery: {
          sm: 24,
          lg: 28
        }
      },
      xl: {
        mediaQuery: {
          sm: 20,
          lg: 24
        }
      },
      lg: {
        mediaQuery: {
          sm: 18,
          lg: 20
        }
      },
      md: {
        mediaQuery: {
          sm: 16,
          lg: 16
        }
      },
      sm: {
        mediaQuery: {
          sm: 12,
          lg: 14
        }
      },
      xs: {
        mediaQuery: {
          sm: 12,
          lg: 12
        }
      }
    },
    size: {
      d1: {
        mediaQuery: {
          sm: 80,
          lg: 120
        }
      },
      d2: {
        mediaQuery: {
          sm: 64,
          lg: 96
        }
      },
      d3: {
        mediaQuery: {
          sm: 64,
          lg: 80
        }
      },
      d4: {
        mediaQuery: {
          sm: 48,
          lg: 64
        }
      },
      "4xl": {
        mediaQuery: {
          sm: 32,
          lg: 48
        }
      },
      "3xl": {
        mediaQuery: {
          sm: 28,
          lg: 32
        }
      },
      "2xl": {
        mediaQuery: {
          sm: 24,
          lg: 28
        }
      },
      xl: {
        mediaQuery: {
          sm: 20,
          lg: 24
        }
      },
      lg: {
        mediaQuery: {
          sm: 18,
          lg: 20
        }
      },
      md: {
        mediaQuery: {
          sm: 16,
          lg: 16
        }
      },
      sm: {
        mediaQuery: {
          sm: 12,
          lg: 14
        }
      },
      xs: {
        mediaQuery: {
          sm: 12,
          lg: 12
        }
      }
    },
    weight: {
      book: 450,
      bold: 700,
      black: 900
    }
  },
  mediaQuery: {
    small: 576,
    medium: 960,
    large: 1200
  },
  customMediaQuery: {
    "small-and-up": 576,
    "medium-and-up": 960,
    "large-and-up": 1200
  },
  opacity: {
    solid: 1,
    translucent: 0.75,
    transparent: 0.25
  },
  space: {
    0: 0,
    25: 1,
    50: 2,
    100: 4,
    200: 8,
    300: 12,
    350: 14,
    400: 16,
    450: 18,
    500: 20,
    550: 22,
    600: 24,
    700: 28,
    800: 32,
    900: 36,
    1e3: 40,
    1100: 44,
    1200: 48,
    1300: 52,
    1400: 56,
    1500: 60,
    1600: 64,
    1800: 72,
    2e3: 80,
    2400: 96,
    3e3: 120,
    3500: 140,
    base: 4
  },
  button: {
    color: {
      focus: {
        blue: "#4F66DE",
        white: "#FFFFFF"
      }
    },
    surface: {
      color: {
        fg: "#FFFFFF",
        bg: "#00261C",
        bgVariant: "#EBE7E3",
        bgHover: "#044D29",
        fgInverted: "#00261C",
        bgInverted: "#FFFFFF",
        bgInvertedHover: "#FFFFFF"
      }
    },
    destructive: {
      color: {
        fg: "#FFFFFF",
        bg: "#D62349",
        bgHover: "#AE072C"
      }
    }
  },
  input: {
    color: {
      label: "#00261C",
      border: "#635E58",
      borderError: "#AE072C",
      hint: "#635E58",
      selected: "#1F3BCD",
      selectedTint: "#EBEFFF"
    }
  }
}, v = {
  color: {
    neutral: {
      20: "#F9F6F3",
      30: "#EBE7E3",
      40: "#D4CFCB",
      50: "#8F8982",
      60: "#635E58",
      70: "#3F3B36",
      80: "#292929",
      white: "#FFFFFF",
      black: "#000000"
    },
    red: {
      20: "#FFEBEF",
      30: "#F5B2C1",
      40: "#EB748E",
      50: "#E04A6A",
      60: "#D62349",
      70: "#AE072C",
      80: "#730019"
    },
    orange: {
      20: "#FFEDE5",
      30: "#FFC6AD",
      40: "#F89B73",
      50: "#F17B49",
      60: "#E95D21",
      70: "#C13E06"
    },
    yellow: {
      70: "#CB7D07",
      80: "#8F5600"
    },
    green: {
      20: "#ADEAA6",
      30: "#3BE44C",
      40: "#16B639",
      50: "#0A9828",
      60: "#007226",
      70: "#044D29",
      80: "#00261C",
      90: "#051C16"
    },
    blue: {
      20: "#EBEFFF",
      30: "#AEBAFB",
      40: "#788AE9",
      50: "#4F66DE",
      60: "#1F3BCD",
      70: "#001EB2"
    },
    alert: {
      success: "#044D29",
      successTint: "#ADEAA6",
      warning: "#C13E06",
      warningTint: "#FFEDE5",
      error: "#AE072C",
      errorTint: "#FFEBEF",
      info: "#1F3BCD",
      infoTint: "#EBEFFF",
      neutral: "#001EB2",
      neutralTint: "#AEBAFB",
      border: "#FFFFFF"
    },
    input: {
      borderDim: "#EBE7E3"
    },
    brand: {
      brand: "#0A9828",
      dark: "#00261C",
      dim: "#044D29",
      bold: "#3BE44C",
      bright: "#ADEAA6",
      gradientFrom: "#ADEAA6",
      gradientTo: "#16B639",
      onBrand: "#FFFFFF",
      onBrandVariant: "#ADEAA6",
      fixed: {
        brand: "#0A9828",
        dark: "#00261C",
        dim: "#044D29",
        bold: "#3BE44C",
        bright: "#ADEAA6",
        onBrand: "#FFFFFF",
        onBrandVariant: "#ADEAA6"
      }
    },
    outline: {
      outer: "#4F66DE",
      inner: "#FFFFFF"
    },
    surface: {
      surface: "#F9F6F3",
      bright: "#FFFFFF",
      dim: "#EBE7E3",
      onSurface: "#00261C",
      onSurfaceVariant: "#635E58",
      border: "#EBE7E3",
      borderDim: "#D4CFCB",
      link: "#044D29",
      electricity: "#CB7D07",
      gas: "#4F66DE",
      fadeFrom: "#00261C",
      fadeTo: "#00261C",
      fixed: {
        onSurface: "#FFFFFF",
        bright: "#00261C"
      }
    }
  },
  transition: {
    duration: {
      fast: "0.2s ease",
      medium: "0.3s ease",
      slow: "0.5s ease"
    }
  },
  unit: {
    0: "0",
    25: "1px",
    50: "2px",
    100: "4px",
    200: "8px",
    300: "12px",
    350: "14px",
    400: "16px",
    450: "18px",
    500: "20px",
    550: "22px",
    600: "24px",
    700: "28px",
    800: "32px",
    900: "36px",
    1e3: "40px",
    1100: "44px",
    1200: "48px",
    1300: "52px",
    1400: "56px",
    1500: "60px",
    1600: "64px",
    1800: "72px",
    2e3: "80px",
    2400: "96px",
    3e3: "120px",
    3500: "140px"
  },
  border: {
    radius: {
      xs: "2px",
      sm: "4px",
      md: "8px",
      lg: "12px",
      xl: "16px",
      "2xl": "22px",
      "3xl": "32px"
    },
    width: {
      sm: "1px",
      md: "2px",
      lg: "4px"
    }
  },
  breakpoint: {
    small: "576px",
    medium: "960px",
    large: "1200px"
  },
  native: {
    font: {
      family: {
        black: "OVOCircularTT-Black",
        book: "OVOCircularTT-Book",
        bold: "OVOCircularTT-Bold"
      }
    }
  },
  web: {
    font: {
      family: "'OVOCircular', Futura, 'Century Gothic', sans-serif"
    }
  },
  font: {
    letterSpacing: {
      d1: {
        mediaQuery: {
          sm: "-3px",
          lg: "-6px"
        }
      },
      d2: {
        mediaQuery: {
          sm: "-2.5px",
          lg: "-5px"
        }
      },
      d3: {
        mediaQuery: {
          sm: "-2px",
          lg: "-4px"
        }
      },
      d4: {
        mediaQuery: {
          sm: "-1.5px",
          lg: "-3px"
        }
      },
      "4xl": {
        mediaQuery: {
          sm: "-1px",
          lg: "-2px"
        }
      },
      "3xl": {
        mediaQuery: {
          sm: "-0.5px",
          lg: "-1px"
        }
      },
      "2xl": {
        mediaQuery: {
          sm: "-0.5px",
          lg: "-1px"
        }
      },
      xl: {
        mediaQuery: {
          sm: "-0.5px",
          lg: "-1px"
        }
      },
      lg: {
        mediaQuery: {
          sm: "0",
          lg: "0"
        }
      },
      md: {
        mediaQuery: {
          sm: "0",
          lg: "0"
        }
      },
      sm: {
        mediaQuery: {
          sm: "0",
          lg: "0"
        }
      },
      xs: {
        mediaQuery: {
          sm: "0",
          lg: "0"
        }
      }
    },
    lineHeight: {
      d1: {
        mediaQuery: {
          sm: "80px",
          lg: "120px"
        }
      },
      d2: {
        mediaQuery: {
          sm: "64px",
          lg: "96px"
        }
      },
      d3: {
        mediaQuery: {
          sm: "64px",
          lg: "80px"
        }
      },
      d4: {
        mediaQuery: {
          sm: "48px",
          lg: "64px"
        }
      },
      "4xl": {
        mediaQuery: {
          sm: "32px",
          lg: "48px"
        }
      },
      "3xl": {
        mediaQuery: {
          sm: "32px",
          lg: "40px"
        }
      },
      "2xl": {
        mediaQuery: {
          sm: "28px",
          lg: "36px"
        }
      },
      xl: {
        mediaQuery: {
          sm: "28px",
          lg: "32px"
        }
      },
      lg: {
        mediaQuery: {
          sm: "24px",
          lg: "28px"
        }
      },
      md: {
        mediaQuery: {
          sm: "20px",
          lg: "24px"
        }
      },
      sm: {
        mediaQuery: {
          sm: "16px",
          lg: "20px"
        }
      },
      xs: {
        mediaQuery: {
          sm: "14px",
          lg: "14px"
        }
      }
    },
    paragraphSpace: {
      d1: {
        mediaQuery: {
          sm: "48px",
          lg: "64px"
        }
      },
      d2: {
        mediaQuery: {
          sm: "64px",
          lg: "80px"
        }
      },
      d3: {
        mediaQuery: {
          sm: "64px",
          lg: "96px"
        }
      },
      d4: {
        mediaQuery: {
          sm: "80px",
          lg: "120px"
        }
      },
      "4xl": {
        mediaQuery: {
          sm: "32px",
          lg: "48px"
        }
      },
      "3xl": {
        mediaQuery: {
          sm: "28px",
          lg: "32px"
        }
      },
      "2xl": {
        mediaQuery: {
          sm: "24px",
          lg: "28px"
        }
      },
      xl: {
        mediaQuery: {
          sm: "20px",
          lg: "24px"
        }
      },
      lg: {
        mediaQuery: {
          sm: "18px",
          lg: "20px"
        }
      },
      md: {
        mediaQuery: {
          sm: "16px",
          lg: "16px"
        }
      },
      sm: {
        mediaQuery: {
          sm: "12px",
          lg: "14px"
        }
      },
      xs: {
        mediaQuery: {
          sm: "12px",
          lg: "12px"
        }
      }
    },
    size: {
      d1: {
        mediaQuery: {
          sm: "80px",
          lg: "120px"
        }
      },
      d2: {
        mediaQuery: {
          sm: "64px",
          lg: "96px"
        }
      },
      d3: {
        mediaQuery: {
          sm: "64px",
          lg: "80px"
        }
      },
      d4: {
        mediaQuery: {
          sm: "48px",
          lg: "64px"
        }
      },
      "4xl": {
        mediaQuery: {
          sm: "32px",
          lg: "48px"
        }
      },
      "3xl": {
        mediaQuery: {
          sm: "28px",
          lg: "32px"
        }
      },
      "2xl": {
        mediaQuery: {
          sm: "24px",
          lg: "28px"
        }
      },
      xl: {
        mediaQuery: {
          sm: "20px",
          lg: "24px"
        }
      },
      lg: {
        mediaQuery: {
          sm: "18px",
          lg: "20px"
        }
      },
      md: {
        mediaQuery: {
          sm: "16px",
          lg: "16px"
        }
      },
      sm: {
        mediaQuery: {
          sm: "12px",
          lg: "14px"
        }
      },
      xs: {
        mediaQuery: {
          sm: "12px",
          lg: "12px"
        }
      }
    },
    weight: {
      book: 450,
      bold: 700,
      black: 900
    }
  },
  mediaQuery: {
    small: "@media screen and (min-width: 577px)",
    medium: "@media screen and (min-width: 961px)",
    large: "@media screen and (min-width: 1201px)"
  },
  customMediaQuery: {
    "small-and-up": "(min-width: 577px)",
    "medium-and-up": "(min-width: 961px)",
    "large-and-up": "(min-width: 1201px)"
  },
  opacity: {
    solid: 1,
    translucent: 0.75,
    transparent: 0.25
  },
  space: {
    0: "0",
    25: "1px",
    50: "2px",
    100: "4px",
    200: "8px",
    300: "12px",
    350: "14px",
    400: "16px",
    450: "18px",
    500: "20px",
    550: "22px",
    600: "24px",
    700: "28px",
    800: "32px",
    900: "36px",
    1e3: "40px",
    1100: "44px",
    1200: "48px",
    1300: "52px",
    1400: "56px",
    1500: "60px",
    1600: "64px",
    1800: "72px",
    2e3: "80px",
    2400: "96px",
    3e3: "120px",
    3500: "140px",
    base: "4px"
  },
  button: {
    color: {
      focus: {
        blue: "#4F66DE",
        white: "#FFFFFF"
      }
    },
    surface: {
      color: {
        fg: "#FFFFFF",
        bg: "#00261C",
        bgVariant: "#EBE7E3",
        bgHover: "#044D29",
        fgInverted: "#00261C",
        bgInverted: "#FFFFFF",
        bgInvertedHover: "#FFFFFF"
      }
    },
    destructive: {
      color: {
        fg: "#FFFFFF",
        bg: "#D62349",
        bgHover: "#AE072C"
      }
    }
  },
  input: {
    color: {
      label: "#00261C",
      border: "#635E58",
      borderError: "#AE072C",
      hint: "#635E58",
      selected: "#1F3BCD",
      selectedTint: "#EBEFFF"
    }
  }
}, n;
(function(e) {
  e.WEB = "web", e.NATIVE = "native";
})(n || (n = {}));
var w = v, j = T;
function V(e, r, a) {
  a === void 0 && (a = n.WEB);
  var m = { arrayMerge: function(M, x) {
    return x;
  } }, i = a === n.WEB ? w : j, F = s(e, r || {}, m);
  return s(i, F, m);
}
export {
  n as P,
  j as a,
  v as b,
  V as c,
  w as d,
  T as t
};
